import type { ProvinceSnapshotDto } from '../api/intel';
import type { KingdomMember } from '../types/kingdom';

export interface KingdomSnapshotContext {
  kingdomId: string;
  kingdomName: string;
  kingdomNw: number;
  kingdomLand: number;
}

/**
 * Builds a Target Finder-shaped snapshot from roster data already in hand (Kingdom/World Viewer
 * rosters), so clicking a province there can land on the same target-detail view Target Finder
 * uses — without a network round-trip to re-fetch what the roster already has.
 */
export function memberToProvinceSnapshot(member: KingdomMember, kd: KingdomSnapshotContext): ProvinceSnapshotDto {
  return {
    provinceId: member.provinceId,
    provinceName: member.provinceName,
    location: member.location,
    race: member.race,
    rank: member.title,
    networth: member.networth,
    land: member.land,
    nwpa: member.land > 0 ? Math.round(member.networth / member.land) : 0,
    kingdomId: kd.kingdomId,
    kingdomName: kd.kingdomName,
    kingdomNw: kd.kingdomNw,
    kingdomLand: kd.kingdomLand,
    protectionExpiresAtTick: member.protectionExpiresAtTick,
  };
}
